module.exports = __webpack_public_path__ + "img/Matthew Di Ferrante.0162caf2.jpg";